import { GLOBAL_HEADER_TEXT } from "@/components/Shared/HeaderNavTabs/analytics/constant"
export const getUserMenuFragmentEventInfo = (
  textContent = "",
  themeChange = false,
  link = ""
) => {
  if (!themeChange) {
    return JSON.stringify({
      clickInternalLinks: "true",
      eventAction: `my account:${textContent}`,
      eventMsg: "n/a",
      eventName: `my account:${textContent}`,
      eventStatus: "n/a",
      eventType: GLOBAL_HEADER_TEXT,
      internalLinkName: textContent,
      internalLinkPosition: `${GLOBAL_HEADER_TEXT} ${textContent}`,
      internalLinkType: `${GLOBAL_HEADER_TEXT}:navigation`,
      internalLinkURL: "n/a",
      internalLinkZoneName: GLOBAL_HEADER_TEXT,
    })
  } else {
    return JSON.stringify({
      clickInternalLinks: "true",
      eventAction: `${GLOBAL_HEADER_TEXT}:${textContent}`,
      eventName: `${GLOBAL_HEADER_TEXT}:${textContent}`,
      eventType: "navigation",
      internalLinkName: textContent,
      internalLinkPosition: `${GLOBAL_HEADER_TEXT}:${textContent}`,
      internalLinkType: `${GLOBAL_HEADER_TEXT}:mega menu navigation`,
      internalLinkURL: link ? link : "n/a",
      internalLinkZoneName: GLOBAL_HEADER_TEXT,
    })
  }
}
